import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import { API_ROOT } from 'Api/Routes';

function AvatarUser(props) {
  if (props.user && Object.keys(props.user).length > 0) {
    var name = props.user.split(' ')[0];
    var lastName = props.user.split(' ')[1];
    if (props.imageId) {
      return (
        <Avatar
          onClick={props.onClick ? props.onClick : null}
          className="mui-avatar u-mrg-r-10"
          src={`${API_ROOT}/asset/${props.imageId}`}
        />
      );
    } else {
      return (
        <Avatar
          onClick={props.onClick ? props.onClick : null}
          className="mui-avatar u-mrg-r-10"
        >
          {`${name.toUpperCase().charAt(0)}${lastName.toUpperCase().charAt(0)}`}
        </Avatar>
      );
    }
  } else {
    return false;
  }
}

export default AvatarUser;
